import { createContext } from "react";

/**
 * The viewer's saved date and number format.
 *
 * This is deliberately separate from `i18n.language`, which selects the
 * *translation*. A reader can want the interface in English and dates in
 * `en-GB` or `ja-JP` order, and the profile has offered both settings
 * independently since onboarding.
 *
 * `undefined` means "no saved preference reached this subtree" -- either the
 * viewer is signed out, or the component is mounted outside the provider, as
 * every isolated unit test does. `useFormattingLocale` falls back to the
 * interface language there, which is what the app did everywhere before.
 */
export const FormattingLocaleContext = createContext<string | undefined>(undefined);
